











import {Component, Prop, Vue} from 'vue-property-decorator';
import {nil} from '@/common';

@Component({
    components: {},
})
export default class DropZone extends Vue {
    @Prop({default: '.csv'})
    public accept!: string;

    @Prop({default: false})
    public multiple!: boolean;

    @Prop({default: true})
    private enabled!: boolean;
    private highlight = false;

    public openFileSelection(): void {
        if (!this.enabled) {
            return;
        }
        (this.$refs.fileInput as HTMLElement).click();
    }

    public onDragOver(event: DragEvent): void {
        console.log('on drag over!');
        if (!this.enabled) {
            return;
        }
        event.preventDefault();
        this.highlight = true;
    }

    public onDragLeave(event: DragEvent): void {
        console.log('on drag leave!');
        this.highlight = false;
    }

    public onDrop(event: DragEvent): void {
        console.log('on drop!');
        if (!this.enabled) {
            return;
        }
        event.preventDefault();
        if (nil(event.dataTransfer)) {
            return;
        }
        const files = event.dataTransfer.files;
        this.$emit('filesAdded', this.multiple ? files : [files[0]]);
        this.highlight = false;
    }

    public onFileChanged(event: any) {
        const files: FileList = event.target.files;
        const result: File[] = [];
        for (let i = 0; i < files.length; i++) {
            result.push(files.item(i) as File);
        }
        this.$emit('filesAdded', result);
    }
}
